export const IS_LOADING = 'IS_LOADING';
export const NET_HOLDINGS_RESULT_BY = 'NET_HOLDINGS_RESULT_BY';
export const NET_HOLDINGS_SET_SECTOR = 'NET_HOLDINGS_SET_SECTOR';

// async function
export const NET_HOLDING_CHART_DATA = 'NET_HOLDING_CHART_DATA';
export const NET_HOLDING_TOOLTIP_DATA = 'NET_HOLDING_TOOLTIP_DATA';
export const NET_HOLDING_RELOADED_TIME = 'NET_HOLDING_RELOADED_TIME';

export const NET_HOLDING_EXCLUDE_MF = 'NET_HOLDING_EXCLUDE_MF';
export const NET_HOLDING_BROKER_NUMBER = 'NET_HOLDING_BROKER_NUMBER';



// WEBPACK FOOTER //
// ./src/dalalstreet/src/redux/NetHoldings/ActionTypes.ts